import React from "react";
import get from "lodash/get";
import moment from "moment";
import { css, Global } from "@emotion/react";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";

const useStyles = makeStyles((theme) => ({
  headings: {
    color: "#000",
    fontWeight: 800,
    textAlign: "left",
    [theme.breakpoints.down("md")]: {
      fontSize: 15,
    },
  },
  infoLabel: {
    color: "#333333",
    fontWeight: 800,
    [theme.breakpoints.down("md")]: {
      fontSize: 15,
    },
  },
  infoValue: {
    color: "#000",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    [theme.breakpoints.down("md")]: {
      fontSize: 15,
    },
  },
  closeButton: {
    height: 30,
    width: 146,
    borderRadius: 10,
    padding: "5px 10px",
    background: "#1464f6",
  },
  closeButtonText: {
    fontWeight: 800,
  },
  dialogActionWrapper: {
    marginBottom: 10,
  },
}));

const global_styles = css`
  h2.MuiDialogTitle-root {
    font-size: 16px;
    font-weight: 800;
  }
  div.MuiDialog-paperScrollPaper {
    width: 650px;
    border-radius: 15px;
  }
  @media only screen and (max-width: 600px) {
    div.MuiDialog-paperScrollPaper {
      height: auto;
    }
  }
`;

export function EyeIconDialog({ open, onClose, photograph, gallery }) {
  const classes = useStyles();

  const photoName = get(photograph, "photo_name");
  // Use the gallery_session_name from the photograph (the actual gallery the photo belongs to)
  // Fall back to the header gallery's session_name for backwards compatibility
  const galleryName = get(photograph, "gallery_session_name") || get(gallery, "session_name");
  const photographTakenAt = get(photograph, "photograph_taken_at");

  return (
    <div>
      <Global styles={global_styles} />
      <Dialog open={open} disablePortal={true} onClick={onClose}>
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingRight: 1,
            paddingTop: 1,
            paddingBottom: 0,
          }}
        >
          <Typography
            variant="div"
            component="div"
            sx={{ fontWeight: 800, fontSize: 18 }}
          >
            Photo Details
          </Typography>
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Stack
              spacing={1}
              direction="column"
              justifyContent="flex-start"
              alignItems="stretch"
            >
              <Grid container alignItems="baseline">
                <Grid item xs={5}>
                  <Typography sx={{ color: "#333333", fontWeight: 800 }}>
                    Photo Name:
                  </Typography>
                </Grid>
                <Grid item xs={7} sx={{ paddingLeft: 2 }}>
                  <Typography className={classes.infoValue}>
                    {photoName || "N/A"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container alignItems="baseline">
                <Grid item xs={5}>
                  <Typography sx={{ color: "#333333", fontWeight: 800 }}>
                    Gallery:
                  </Typography>
                </Grid>
                <Grid item xs={7} sx={{ paddingLeft: 2 }}>
                  <Typography className={classes.infoValue}>
                    {galleryName || "N/A"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container alignItems="baseline">
                <Grid item xs={5}>
                  <Typography sx={{ color: "#333333", fontWeight: 800 }}>
                    Time Taken:
                  </Typography>
                </Grid>
                <Grid item xs={7} sx={{ paddingLeft: 2 }}>
                  <Typography className={classes.infoValue}>
                    {photographTakenAt
                      ? moment(photographTakenAt).utc().format("HH:mm a")
                      : "N/A"}
                  </Typography>
                </Grid>
              </Grid>
            </Stack>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className={classes.dialogActionWrapper}>
            <Button
              variant="contained"
              onClick={onClose}
              className={classes.closeButton}
            >
              <p className={classes.closeButtonText}>Got it</p>
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default React.memo(EyeIconDialog);
